import React, { useEffect, useState, useContext, useRef } from 'react'
import './searchItems.css'
import { getParameterByName } from '../../../utils/commonFunctions'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import SearchProductList from '../../../Component/ProductCard/product'
import GridProduct from '../../../Component/ProductCard/gridProduct'
import Layout from '../Layout'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FilterPanel from '../../../Product/components/organisms/FilterPanel'
import Loaders from '../../../Product/components/molecules/Loaders'
import { Button, Drawer, SwipeableDrawer } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import SlidePanel from '../../../Component/SlidePanel'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
// import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import CustomSelect from '../../../Product/components/atoms/Inputs/CustomSelect'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { messageHandler } from '../../../Product/common/socketHandler'
import AlertContext from '../../../Product/context/alert/alertContext'
import PaginationComponent from '../../../Component/Pagination'
import { socket, socketAuction } from '../../../Product/common/socket'
import Slider from 'react-slick'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { handleRedirectInternal, useCustomMediaQuery } from '../../../Product/common/components'
import { Link, useHistory, useLocation } from 'react-router-dom'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import HeaderSearchComponent from '../Header/HeaderSearch'
import { sustainabilityOptions, brandsliqutatios, allCondition } from '../../../utils'
import SEO from '../../../utils/CommonFunctionality/SEO'
import { setAuthToken } from '../../../Product/common/api'
import CheckBox from '../../../Product/components/atoms/CheckBox'
import { Box, ListItem, Tab, FormControl, MenuItem } from '@material-ui/core'
import Select from '@material-ui/core/Select'
import InputBase from '@material-ui/core/InputBase'
import CloseIcon from '@material-ui/icons/Close'
import moment from 'moment-timezone'
import { debounce } from 'lodash'
import { DepartureBoard } from '@material-ui/icons'

const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})

const AuctionSearchComponent = (props) => {
    // const [cookies, setCookie] = useCookies(['user_session'])
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const history = useHistory()

    const productContext = useContext(ProductContext)
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    const {
        search_allproducts,
        getAllSearchProducts,
        search_allauctions,
        productLocalState,
        getAllSearchAuctions,
    } = productContext

    const { isAuthenticated, user } = authContext
    const { setAlert } = alertContext

    const classes = useStyles()

    const isBidDepotProject = false

    const [isLoading, setLoading] = useState(true)
    const [viewProduct, setViewProduct] = useState([])
    const [searchCategories, setSearchCategories] = useState([])
    const [states, setStates] = useState([])
    const [listview, setlistview] = useState(false)
    const [totalItems, setTotalItem] = useState(0)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [isFilterVisible, setFilterVisible] = useState(true)
    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)
    const location = useLocation()
    const forMobile = useMediaQuery('(max-width:1024px)')
    const params = new URLSearchParams(window.location.search.substring(1))
    const [open, setOpen] = useState(false)
    const [pages, setPages] = useState(10)
    const [topSort, setTopSort] = useState(0)
    const debouncedFetchProducts = useRef(
        debounce((values) => getAllSearchProducts(values), 300),
    ).current
    const hasScrolled = useRef(false)
    const isBidDepotProjects = document.querySelector('body').classList.contains('BidAuctionDepot')
    const [auctionView, setAuctionView] = useState('Grid')
    useEffect(() => {
        if (forMobile && isBidDepotProjects) {
            setAuctionView('List')
        } else {
            setAuctionView('Grid')
        }
    }, [forMobile && isBidDepotProjects])
    const [auctionSearch, setAuctionSearch] = useState({
        page: 1,
        sh_limit: '10',
        orderby: '9',
        searchbar: '',
        auc_type: '2',
        type: '',
        auction_io: 1,
        lot_images: 1,
    })
    const handleClickOpen = () => {
        setOpen(true)
    }

    //Do not remove this, used to set the end date of the auction in search page
    useEffect(() => {
        getAllSearchAuctions(auctionSearch, 'search')
    }, [auctionSearch])

    const handleClickClose = () => {
        setOpen(false)
    }
    const BootstrapInput = withStyles((theme) => ({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 14,
            padding: '3px 20px 3px 3px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
            },
        },
    }))(InputBase)

    const sortingValue = [30, 50, 100, 150]

    const handleChangePage = (event) => {
        setPages(event.target.value)
    }

    const [sortbyfilter, setSortByFilter] = useState({
        orderby: typeof params.get('sort') !== 'undefined' ? params.get('sort') : '15',
        orderby2: '',
        sortType:
            typeof params.get('sort') !== 'undefined'
                ? params.get('sort') == 14
                    ? 1
                    : params.get('sort') == 15
                    ? 2
                    : ''
                : 2,
    })

    const manageFilterPanel = () => {
        setFilterVisible(!isFilterVisible)
    }

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    // useState(() => {
    //     setAuctionView(window.innerWidth < 600 ? 'List' : 'Grid')
    // }, [])

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }
    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        socket.on('buyer_assurance', (data) => {
            handler(data, 'buyer_assurance')
        })
        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('buyer_assurance', (data) => {
                handler(data, 'buyer_assurance')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
        }
    }, [])
    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    const active_sorts = {
        sorts: {
            sortcategoryTypes: ['2', '4', '5', '7', '8'],
            sortconditionTypes: ['2', '3', '5', '6'],
            sortsubCategoryTypes: ['1', '2', '3'],
            sortlocations: ['1', '2', '3', '18', '20'],
            sortall_notifications: [],
            sortbusiness_category: [],
            sortvat_registration: [],
        },
    }
    const [searchbar] = useState(new URLSearchParams(window.location.search.substring(1)).get('q'))
    const [catg] = useState(new URLSearchParams(window.location.search.substring(1)).get('cat'))
    const [rat] = useState(new URLSearchParams(window.location.search.substring(1)).get('rat'))

    const formik = useFormik({
        initialValues: {
            sh_limit: params.get('slimit') ?? 50,
            page: params.get('page') ?? 1,
            orderby:
                params.get('sort') ??
                global?.storeConfigration?.liquidation_filter_update?.value == 1
                    ? '15'
                    : '',
            location: [],
            sortType:
                global?.storeConfigration?.liquidation_filter_update?.value == 1 ? 2 : undefined,
            state: [],
            city: [],
            category:
                params.get('cat') && params.get('cat').length ? params.get('cat').split(',') : [],
            contenthead5: [],
            subcategory: [],
            condition: [],
            storedate: [],
            enddate: null,
            fromprice: 0,
            toprice: 0,
            totalpage: 5,
            lotof: '',
            searchbar: searchbar ? searchbar : '',
            miles: params.get('m') ? params.get('m') : '',
            from: '',
            closed_auction_list: 0,
            view_type: params.get('view') ? params.get('view') : 0,
            quality_rating:
                params.get('cond') && params.get('cond').length > 0
                    ? params.get('cond')
                    : rat == null || rat === 1 || rat === ''
                    ? []
                    : rat,
            auction_io: 1,
            conditionunique: [],
            lotsize: ['1'],
            orderby2: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '' : '6',
            need_bid_increment: 1,
            auction_city:
                params.get('loc') && params.get('loc').length ? params.get('loc').split(',') : [],
            auction_state: [],
            special_events:
                params.get('edate') && params.get('edate').length
                    ? params.get('edate').split(',')
                    : [],
        },
    })

    console.log('PUKA', totalItems, formik.values.page, formik.values.sh_limit)

    const [viewFilter, setViewFilter] = useState([
        { id: 0, description: 'All' },
        { id: 1, description: 'Auction Lots' },
        { id: 2, description: 'Buy Now Lots' },
    ])
    let filterValues = [
        // {
        //     title: 'View',
        //     type: 'radio',
        //     noLabel: true,
        //     name: 'view_type',
        //     int: 1,
        //     class: 'col-12',
        //     item: viewFilter,
        //     formik: formik,
        // },
        {
            title: `Location${states.length > 1 ? 's' : ''}`,
            type: 'check',
            name: 'auction_city',
            options: states
                .map((location) => {
                    let conditionChanged = {}
                    conditionChanged.description = location.city
                    conditionChanged.id = location.city
                    conditionChanged.name = location.city
                    conditionChanged.value = location.city
                    conditionChanged.active = 1
                    return conditionChanged
                })
                .filter((main) => {
                    return true
                }),
            formik: formik,
        },
        {
            title: 'End Date',
            type: 'check',
            noLabel: true,
            name: 'special_events',
            int: 1,
            options: search_allauctions?.results?.length
                ? search_allauctions?.results
                      .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                      .map((val) => {
                          return {
                              description: moment(val.date_closed).format('dddd MMMM Do'),
                              id: val.id,
                          }
                      })
                : [],
            formik: formik,
        },
        {
            title: 'Categories',
            type: 'check',
            name: 'category',
            options:
                searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                    ? searchCategories
                          .sort((a, b) => a.description.localeCompare(b.description))
                          .filter((main) => {
                              return true
                          })
                    : global.searchCategories
                          .sort((a, b) => a.description.localeCompare(b.description))
                          .filter((main) => {
                              return true
                          }),
            formik: formik,
        },
        {
            title: 'Condition',
            type: 'check',
            noLabel: true,
            name: 'quality_rating',
            int: 1,
            options: global.condition_data.map((item) => {
                return {
                    ...item,
                    description: item.condition,
                }
            }),
            formik: formik,
        },
        // {
        //     title: 'Conditions',
        //     type: 'check',
        //     name: 'conditionunique',
        //     options: allCondition
        //         .filter(
        //             (maincat) =>
        //                 maincat.active === 1 ||
        //                 (formik.values.conditionTypeId &&
        //                     formik.values.conditionTypeId === maincat.id),
        //         )
        //         .map((location) => {
        //             let conditionChanged = {}
        //             conditionChanged.description = location.description
        //             conditionChanged.id = location.id
        //             conditionChanged.name = location.description
        //             conditionChanged.value = location.id
        //             conditionChanged.active = 1
        //             return conditionChanged
        //         })
        //         .sort((a, b) => a.description.localeCompare(b.description))
        //         .filter((main) => {
        //             return true
        //         }),
        //     formik: formik,
        // },

        // {
        //     title: "Seller's",
        //     type: 'check',
        //     name: 'contenthead5',
        //     options: brandsliqutatios
        //         .map((buscat) => {
        //             let busCategoryChanged = {}
        //             busCategoryChanged.description = buscat.description
        //             busCategoryChanged.name = buscat.description
        //             busCategoryChanged.value = buscat.id
        //             busCategoryChanged.id = buscat.id
        //             busCategoryChanged.active = 1
        //             return busCategoryChanged
        //         })
        //         .sort((a, b) => a.description.localeCompare(b.description))
        //         .filter((main) => {
        //             return true
        //         }),
        //     formik: formik,
        // },
        // {
        //     title: 'Lot Size',
        //     type: 'check',
        //     name: 'lotsize',
        //     options: [
        //         {
        //             description: 'Pallet',
        //             name: 'Pallet',
        //             value: 1,
        //             id: 1,
        //         },
        //     ],
        //     formik: formik,
        // },
        // {
        //     title: 'Auction Status',
        //     type: 'radio',
        //     noLabel: true,
        //     name: 'closed_auction_list',
        //     int: 1,
        //     class: 'col-12',
        //     item: [
        //         { id: 0, description: 'Live Items' },
        //         { id: 1, description: 'Closed Items' },
        //     ],
        //     formik: formik,
        // },

        // {
        //     title: 'Sub category',
        //     type: 'check',
        //     name: 'subcategory',
        //     options: global.searchSubCategories.filter((subcat) => {
        //         // if (
        //         //     formik &&
        //         //     formik.values &&
        //         //     formik.values.category &&
        //         //     formik.values.category.length
        //         //         ? formik.values.category.includes(subcat.level_id.toString())
        //         //         : false
        //         // ) {
        //         return true
        //         //}
        //     }),
        //     formik: formik,
        // },
    ]
    useEffect(() => {
        if (search_allproducts.from === 'activeHeader') {
            return
        }

        setLoading(false)

        // if (search_allproducts.from === 'searchPage') {
        if (search_allproducts.results.length > 0) {
            search_allproducts.results.map((data) => {
                if (data?.extra_fields?.includes('}')) {
                    let parse = JSON.parse(data.extra_fields)
                    Object.keys(parse).map((val) => {
                        data[val] = parse[val]
                    })
                }
            })
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
        } else {
            setViewProduct([])
        }
        if (
            search_allproducts?.categoriesCounts?.length > 0 &&
            searchCategories?.length == 0 &&
            global.storeConfigration?.cat_with_count?.value
        ) {
            var new_cat = global.searchCategories
            new_cat.map((value) => {
                value.catcount =
                    search_allproducts.categoriesCounts.filter(
                        (val) => parseInt(val.category_id) == parseInt(value.id),
                    ).length > 0
                        ? search_allproducts.categoriesCounts.filter(
                              (val) => parseInt(val.category_id) == parseInt(value.id),
                          )[0].CountCat
                        : 0
                if (!value.description.includes(value.catcount)) {
                    value.description = `${value.description + ' '}(${value.catcount})`
                }
            })

            setSearchCategories(new_cat)
        }
        setTotalItem(search_allproducts.total_pagecnt)
        setStates(search_allproducts.city)
        // }
    }, [search_allproducts, formik.values])
    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    useEffect(() => {
        const lastLot = sessionStorage.getItem('lastLot')

        if (lastLot && viewProduct?.length !== 0) {
            const element = document.getElementById(`lot-${lastLot}`)
            if (element) {
                // element.scrollIntoView({ behavior: 'smooth', block: 'start' })
                const yOffset = element.getBoundingClientRect().top + window.scrollY + 250
                window.scrollTo({ top: yOffset, behavior: 'smooth' })
                sessionStorage.removeItem('lastLot')
            }
        }
    }, [viewProduct])

    const onHandlePage = (value) => {
        console.log('handle page --', value)
        formik.setFieldValue('page', value)
        window.scrollTo(0, 0)
    }
    useEffect(() => {
        if (localStorage.token) {
            setAuthToken(localStorage.token)
        }
        setLoading(true)
        // if (formik.values.closed_auction_list) {
        //     formik.values.orderby = '7'
        // }
        if (formik.values.view_type == 0) {
            formik.setFieldValue('from', '')
            debouncedFetchProducts({
                ...formik.values,
                quality_rating: undefined,
                rating_multiple_io: global.condition_data
                    .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                    .map((item) => item.condition),
            })
        } else if (formik.values.view_type == 1) {
            formik.setFieldValue('from', 'auction_only')
            if (formik.values.from === 'auction_only') {
                debouncedFetchProducts({
                    ...formik.values,
                    quality_rating: undefined,
                    rating_multiple_io: global.condition_data
                        .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                        .map((item) => item.condition),
                })
            }
        } else if (formik.values.view_type == 2) {
            formik.setFieldValue('from', 'buynow')
            if (formik.values.from === 'buynow') {
                debouncedFetchProducts({
                    ...formik.values,
                    quality_rating: undefined,
                    rating_multiple_io: global.condition_data
                        .filter((item) => formik.values.quality_rating.includes(item.id.toString()))
                        .map((item) => item.condition),
                })
            }
        }
        let currentUrl = new URL(window.location.href)
        if (currentUrl.searchParams.has('edate')) {
            currentUrl.searchParams.set('edate', formik.values.special_events)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('loc')) {
            currentUrl.searchParams.set('loc', formik.values.auction_city)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('cond')) {
            currentUrl.searchParams.set('cond', formik.values.quality_rating)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('cat')) {
            currentUrl.searchParams.set('cat', formik.values.category)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('sort')) {
            currentUrl.searchParams.set('sort', formik.values.orderby)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('slimit')) {
            currentUrl.searchParams.set('slimit', formik.values.sh_limit)
            window.history.replaceState({}, '', currentUrl)
        }
        if (currentUrl.searchParams.has('page')) {
            console.log(' formik.values.page ----', formik.values.page)
            currentUrl.searchParams.set('page', formik.values.page)
            window.history.replaceState({}, '', currentUrl)
        }
        window.scrollTo(0, 0)
    }, [formik.values])

    // useEffect(() => {
    //     formik.setFieldValue('page', 1)
    // }, [formik.values.view_type])
    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        formik.setFieldValue('miles', params.get('m') ? params.get('m') : '')
        formik.setFieldValue('searchbar', params.get('q') ? params.get('q') : '')
        formik.setFieldValue('view_type', params.get('view') ? params.get('view') : 0)
        if (global?.storeConfigration?.liquidation_filter_update?.value != 1) {
            formik.setFieldValue('orderby', params.get('sort') ? params.get('sort') : '')
        }
        if (typeof params.get('cat') !== 'undefined') {
            formik.setFieldValue('category', params.get('cat') ? params.get('cat').split(',') : [])
        }
        if (typeof params.get('sort') !== 'undefined')
            setSortByFilter({
                orderby:
                    typeof params.get('sort') !== 'undefined'
                        ? params.get('sort')
                        : global?.storeConfigration?.liquidation_filter_update?.value == 1
                        ? '15'
                        : '',
                orderby2: '',
                sortType:
                    typeof params.get('sort') !== 'undefined'
                        ? params.get('sort') == 14
                            ? 1
                            : params.get('sort') == 15
                            ? 2
                            : ''
                        : global?.storeConfigration?.liquidation_filter_update?.value == 1
                        ? 2
                        : undefined,
            })
        if (typeof params.get('loc') !== 'undefined') {
            formik.setFieldValue(
                'auction_city',
                params.get('loc') && params.get('loc').length ? params.get('loc').split(',') : [],
            )
        }

        if (typeof params.get('edate') !== 'undefined') {
            formik.setFieldValue(
                'special_events',
                params.get('edate') && params.get('edate').length
                    ? params.get('edate').split(',')
                    : [],
            )
        }

        if (typeof params.get('cond') !== 'undefined') {
            formik.setFieldValue(
                'quality_rating',
                params.get('cond') && params.get('cond').length > 0
                    ? params.get('cond').split(',')
                    : [],
            )
        }
        formik.setFieldValue('sh_limit', params.get('slimit') ?? 50)
        if (typeof params.get('page') !== 'undefined') {
            console.log('windows location ---', params.get('page'))
            formik.setFieldValue('page', params.get('page') ?? 1)
        }
    }, [window.location.search])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const handleClose = () => {
        params.delete('product')
        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        })
        setSelectedProduct(null)
    }

    const handleClick = async (id) => {
        sessionStorage.setItem('lastLot', id)

        if (props.fromComponent === 'home') {
            setSelectedProduct(id)
        } else {
            params.set('product', id)

            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            })
        }
    }

    useEffect(() => {
        var product_id = params.get('product')
        if (product_id && !selectedProduct) {
            setSelectedProduct(product_id)
        }
    }, [window.location.search])
    const pageOptions = [
        {
            value: '30',
            show: 'Results 30 per page',
        },
        {
            value: '50',
            show: 'Results 50 per page',
        },
        {
            value: '100',
            show: 'Results 100 per page',
        },
        {
            value: '150',
            show: 'Results 150 per page',
        },
    ]

    const sortShow1 = [
        {
            value: 15,
            show: 'Todays Top Deals',
        },
        {
            value: 3,
            show: 'Current price low to high',
        },
        {
            value: 11,
            show: 'Current price high to low',
        },

        {
            value: 2,
            show: 'Recently listed',
        },
        {
            value: '',
            show: 'Deals Ending Soon',
        },
        {
            value: 14,
            show: 'Best Deals',
        },
    ]

    const sortShow = [
        {
            value: 15,
            show: 'Todays Top Deals',
        },
        {
            value: 3,
            show: 'Current price low to high',
        },
        {
            value: 11,
            show: 'Current price high to low',
        },

        {
            value: 2,
            show: 'Recently listed',
        },
        {
            value: '',
            show: 'Deals Ending Soon',
        },
        {
            value: 14,
            show: 'Best Deals',
        },
    ]
    const [checked, setChecked] = useState(
        global?.storeConfigration?.liquidation_filter_update?.value == 1 ? false : true,
    )
    const settings = {
        dots: true,
        fade: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
    }
    const handleRedirect = (data) => {
        // console.log(data)
        // console.log(global.multipleBannersFields[data])
        if (!isAuthenticated) {
            handleRedirectInternal(history, 'sign-up')
        } else {
            // window.location.href = JSON.parse(
            //     global.multipleBannersFields[data].fields
            //         ? global.multipleBannersFields[data].fields
            //         : '{}',
            // ).btn_link
        }
    }

    const handleSortByFilter = (event) => {
        const value = event.target.value
        if (value == '14') {
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: 1,
                }
            })
        } else if (value == '15') {
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: 2,
                }
            })
        } else if (value == '') {
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '6',
                    sortType: '',
                }
            })
        } else if (value == '11') {
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        } else if (value == '3') {
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        } else if (value == '2') {
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        }
    }
    useEffect(() => {
        switch (topSort) {
            case 0:
                formik.setValues({
                    ...formik.values,
                    orderby: '',
                    closed_auction_list: 0,
                    current: 1,
                    upcoming: undefined,
                    need_bid_increment: 1,

                    auction_location: 1,
                })
                break
            case 1:
                formik.setValues({
                    ...formik.values,
                    orderby: '2',
                    closed_auction_list: 1,
                    current: undefined,
                    upcoming: undefined,
                    need_bid_increment: 0,

                    auction_location: 1,
                })
                break
            case 2:
                formik.setValues({
                    ...formik.values,
                    orderby: '2',
                    closed_auction_list: 0,
                    current: undefined,
                    upcoming: undefined,
                    need_bid_increment: 1,

                    auction_location: 1,
                })
                break
            case 3:
                formik.setValues({
                    ...formik.values,
                    orderby: '',
                    closed_auction_list: 0,
                    current: undefined,
                    upcoming: undefined,
                    ending_soon: 1,
                    need_bid_increment: 1,

                    auction_location: 1,
                })
                break
            case 4:
                formik.setValues({
                    ...formik.values,
                    orderby: '15',
                    closed_auction_list: 0,
                    current: undefined,
                    upcoming: 0,
                    orderby2: 0,
                    need_bid_increment: 1,

                    sortType: 2,
                    auction_location: 1,
                })
                break
            case 5:
                formik.setValues({
                    ...formik.values,
                    orderby: '15',
                    closed_auction_list: 0,
                    upcoming: 1,
                    current: undefined,
                    need_bid_increment: 1,

                    auction_location: 1,
                })
                break
        }
    }, [topSort])
    useEffect(() => {
        if (global?.storeConfigration?.liquidation_filter_update?.value == 1) {
            if (formik.values.orderby !== sortbyfilter.orderby) {
                console.log('came to sort api')
                formik.setValues({
                    ...formik.values,
                    orderby: sortbyfilter.orderby,
                    orderby2: sortbyfilter.orderby2,
                    sortType: sortbyfilter.sortType,
                })
            }
        }
    }, [sortbyfilter])
    useEffect(() => {
        if (checked) {
            formik.setFieldValue('orderby2', `6`)
        } else {
            formik.setFieldValue('orderby2', ``)
        }
    }, [checked])
    useEffect(() => {
        if (
            global?.storeConfigration?.liquidation_filter_update?.value !== '1' &&
            formik.values.orderby == '2'
        ) {
            formik.setFieldValue('orderby2', '')
            setChecked(false)
        }
    }, [formik.values.orderby])

    const handleSortChange = (value) => {
        switch (value) {
            case 0:
                formik.setValues({
                    ...formik.values,
                    orderby: '',
                    closed_auction_list: 0,
                    current: 1,
                    upcoming: undefined,
                    need_bid_increment: 1,
                    page: 1,
                    auction_location: 1,
                })
                break
            case 1:
                formik.setValues({
                    ...formik.values,
                    orderby: '2',
                    closed_auction_list: 1,
                    current: undefined,
                    upcoming: undefined,
                    need_bid_increment: 0,
                    page: 1,
                    auction_location: 1,
                })
                break
            case 2:
                formik.setValues({
                    ...formik.values,
                    orderby: '2',
                    closed_auction_list: 0,
                    current: undefined,
                    upcoming: undefined,
                    need_bid_increment: 1,
                    page: 1,
                    auction_location: 1,
                })
                break
            case 3:
                formik.setValues({
                    ...formik.values,
                    orderby: '',
                    closed_auction_list: 0,
                    current: undefined,
                    upcoming: undefined,
                    ending_soon: 1,
                    need_bid_increment: 1,
                    page: 1,
                    auction_location: 1,
                })
                break
            case 4:
                formik.setValues({
                    ...formik.values,
                    orderby: '15',
                    closed_auction_list: 0,
                    current: undefined,
                    upcoming: 0,
                    orderby2: 0,
                    need_bid_increment: 1,
                    page: 1,
                    sortType: 2,
                    auction_location: 1,
                })
                break
            case 5:
                formik.setValues({
                    ...formik.values,
                    orderby: '15',
                    closed_auction_list: 0,
                    upcoming: 1,
                    current: undefined,
                    need_bid_increment: 1,
                    page: 1,
                    auction_location: 1,
                })
                break
        }
    }

    return (
        <Layout props={props}>
            <SEO title={`${global?.storeDetails?.name} | Search`} />
            {/* {global.multipleBannersFields.length ? (
                <div className="siteBanner multiple">
                    {
                        <Slider {...settings}>
                            {global.multipleBannersFields?.map((data, index) => (
                                <>
                                    <img
                                        src={
                                            process.env.REACT_APP_AUCTION_IMAGE_URL +
                                            '/' +
                                            data?.image_name
                                        }
                                    />
                                    <div className="bannerContent">
                                        <h2 className="pb-4">
                                            {JSON.parse(data.fields ? data.fields : '{}').title}
                                        </h2>
                                        <PrimaryButton
                                            label={
                                                isAuthenticated
                                                    ? JSON.parse(data.fields ? data.fields : '{}')
                                                          .btn_text
                                                    : 'Sign Up'
                                            }
                                            type="button"
                                            onClick={() =>
                                                !isAuthenticated
                                                    ? handleRedirectInternal(history, 'sign-up')
                                                    : (window.location.href = JSON.parse(
                                                          global.multipleBannersFields[index].fields
                                                              ? global.multipleBannersFields[index]
                                                                    .fields
                                                              : '{}',
                                                      ).btn_link)
                                            }
                                        />
                                    </div>
                                </>
                            ))}
                        </Slider>
                    }
                </div>
            ) : (
                <div className="siteBanner">
                    <LazyLoadImage
                        src={global?.storeDetails?.bannerValue}
                        alt={`${global?.storeDetails?.name} banner`}
                        effect="blur"
                        height="100%"
                        width="100%"
                    />
                    <div className="bannerContent">
                        <h2>{global?.storeDetails?.description}</h2>
                        <PrimaryButton
                            label="Explore Now"
                            onClick={() =>
                                handleRedirectInternal(
                                    history,
                                    `${isAuthenticated ? 'search' : 'sign-up'}`,
                                )
                            }
                        />
                    </div>
                </div>
            )} */}

            <div className="customContainer mt-5 position-relative " id="search-view">
                {forMobile ? (
                    <>
                        {/* <div className="sotingBtngrp mb-3 justify-content-end">
                            <PrimaryButton
                                label="Active"
                                className={formik.values.closed_auction_list == 0 ? 'active' : ''}
                                onClick={() => formik.setFieldValue('closed_auction_list', 0)}
                            />
                            <PrimaryButton
                                label="Completed"
                                className={formik.values.closed_auction_list == 1 ? 'active' : ''}
                                onClick={() => formik.setFieldValue('closed_auction_list', 1)}
                            />
                        </div>
                        <div className="auctionsMiscFilter">
                            {global?.storeConfigration?.liquidation_filter_update?.value ==
                            1 ? null : (
                                <CheckBox
                                    name="orderby"
                                    label="Time Remaining"
                                    className="asdasd"
                                    checked={checked}
                                    onChange={(event) => setChecked(!checked)}
                                />
                            )}

                            <div className="gridListToggle">
                                <Button
                                    className={auctionView === 'Grid' ? 'active' : ''}
                                    onClick={() => setAuctionView('Grid')}
                                >
                                    <span className="material-icons">apps</span>
                                </Button>
                                <Button
                                    className={auctionView === 'List' ? 'active' : ''}
                                    onClick={() => setAuctionView('List')}
                                >
                                    <span className="material-icons">view_list</span>
                                </Button>
                            </div>
                        </div> */}
                        {/* <div className="mblStckyFilter py-3">
                            <CustomSelect
                                label="Results per page"
                                name="resultsPerPage"
                                selectType="noBorder"
                                value={formik.values.sh_limit}
                                size="small"
                                onChange={(event, editor) => {
                                     = 1formik.values.page
                                    formik.setFieldValue('sh_limit', event.target.value)
                                    sessionStorage.setItem('sh_limit', event.target.value)
                                }}
                            >
                                {pageOptions.map((opt, optindex) => (
                                    <option value={opt.value}>{opt.show}</option>
                                ))}
                            </CustomSelect>

                            <CustomSelect
                                label="Sort by"
                                value={formik.values.orderby}
                                size="small"
                                selectType="noBorder"
                                name="orderby"
                                shrink={search.orderby !== '' ? true : false}
                                onChange={(event, editor) => {
                                    {
                                        global?.storeConfigration?.liquidation_filter_update
                                            ?.value == 1 &&
                                        global?.storeConfigration?.liquidation_filter_update
                                            ?.value !== undefined
                                            ? handleSortByFilter(event)
                                            : formik.setFieldValue('orderby', event.target.value)
                                    }
                                }}
                            >
                                {global?.storeConfigration?.liquidation_filter_update?.value == 1
                                    ? sortShow1.map((opt, optindex) => (
                                          <option value={opt.value}>{opt.show}</option>
                                      ))
                                    : sortShow.map((opt, optindex) => (
                                          <option value={opt.value}>{opt.show}</option>
                                      ))}
                            </CustomSelect>
                            {useCustomMediaQuery('(max-width: 1024px)') && (
                                <Button
                                    className="filterButton w-100"
                                    variant="outlined"
                                    onClick={toggleDrawer('bottom', true)}
                                >
                                    Filters
                                </Button>
                            )}
                            {checkBeachThemeClassName ? (
                                ''
                            ) : (
                                <Button
                                    className="filterButton w-100"
                                    variant="outlined"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'dashboard/mybids')
                                    }
                                >
                                    My Bids
                                </Button>
                            )}
                        </div> */}

                        {/* <div className="auctionSearchPaginationTop">
                            <PaginationComponent
                                onPageChange={onHandlePage}
                                totalProductCount={totalItems}
                                currentPage={formik.values.page}
                                resultToShow={formik.values.sh_limit}
                            />
                        </div> */}

                        <div className="sotingBtngrp search mb-3 justify-content-start">
                            <PrimaryButton
                                label="Active"
                                className={topSort == 0 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(0)
                                    handleSortChange(0)
                                }}
                            />
                            <PrimaryButton
                                label="Upcoming"
                                className={topSort == 5 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(5)
                                    handleSortChange(5)
                                }}
                            />
                            <PrimaryButton
                                label="Completed"
                                className={topSort == 1 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(1)
                                    handleSortChange(1)
                                }}
                            />
                            <PrimaryButton
                                label="Newest"
                                className={topSort == 2 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(2)
                                    handleSortChange(2)
                                }}
                            />
                            <PrimaryButton
                                label="Ending Soon"
                                className={topSort == 3 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(3)
                                    handleSortChange(3)
                                }}
                            />
                            <PrimaryButton
                                label="Most Popular"
                                className={topSort == 4 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(4)
                                    handleSortChange(4)
                                }}
                            />
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: '18px 0px',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>
                                {' '}
                                <Button
                                    variant="none"
                                    color="primary"
                                    onClick={handleClickOpen}
                                    endIcon={<ArrowDropDownIcon />}
                                    style={{
                                        padding: '0px',
                                        margin: '0px',
                                        fontSize: '14px',
                                        fontWeight: '700',
                                    }}
                                >
                                    FILTERS
                                </Button>
                                <Drawer
                                    anchor="bottom"
                                    open={open}
                                    onClose={handleClickClose}
                                    sx={{
                                        '& .MuiDrawer-paper': {
                                            height: '100vh',
                                            width: '100vw',
                                            padding: '16px',
                                        },
                                    }}
                                    BackdropProps={{
                                        style: { backgroundColor: 'transparent' },
                                    }}
                                    PaperProps={{
                                        style: {
                                            zIndex: 999,
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            // height: '65vh',
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            // padding: '24px',
                                            overflow: 'scroll',
                                            marginBottom: '79px',
                                        }}
                                    >
                                        <Button
                                            aria-label="close"
                                            onClick={handleClickClose}
                                            style={{
                                                position: 'absolute',
                                                top: '5px',
                                                right: '5px',
                                            }}
                                        >
                                            <CloseIcon />
                                        </Button>
                                        <FilterPanel formik={formik} filterValues={filterValues} />
                                    </Box>
                                </Drawer>
                            </div>
                            <div className="gridListToggleActive">
                                <Button
                                    className={auctionView === 'Grid' ? 'active' : ''}
                                    onClick={() => setAuctionView('Grid')}
                                    style={{ padding: '0px', margin: '0px' }}
                                >
                                    <span className="material-icons">apps</span>
                                    <span style={{ fontSize: '12px' }}>Grid</span>
                                </Button>
                                <Button
                                    className={auctionView === 'List' ? 'active' : ''}
                                    onClick={() => setAuctionView('List')}
                                    style={{ padding: '0px', margin: '0px' }}
                                >
                                    <span className="material-icons">view_list</span>
                                    <span style={{ fontSize: '12px' }}>List</span>
                                </Button>
                            </div>
                            <div
                                className="resultShow"
                                style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
                            >
                                <span style={{ fontSize: '12px', fontWeight: '500' }}>
                                    Show Results
                                </span>
                                <FormControl>
                                    <Select
                                        labelId="demo-customized-select-label"
                                        id="demo-customized-select"
                                        value={formik.values.sh_limit || 50}
                                        onChange={(event, editor) => {
                                            formik.setFieldValue('page', 1)
                                            formik.setFieldValue('sh_limit', event.target.value)
                                            sessionStorage.setItem('sh_limit', event.target.value)
                                        }}
                                        input={<BootstrapInput />}
                                        defaultValue={50}
                                    >
                                        {sortingValue.map((data, index) => (
                                            <MenuItem value={data} key={index}>
                                                {data}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="sotingBtngrp search mb-3 justify-content-end sortBargainGrp">
                            <PrimaryButton
                                label="Active"
                                className={topSort == 0 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(0)
                                    handleSortChange(0)
                                }}
                            />
                            <PrimaryButton
                                label="Upcoming"
                                className={topSort == 5 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(5)
                                    handleSortChange(5)
                                }}
                            />
                            <PrimaryButton
                                label="Completed"
                                className={topSort == 1 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(1)
                                    handleSortChange(1)
                                }}
                            />
                            <PrimaryButton
                                label="Newest"
                                className={topSort == 2 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(2)
                                    handleSortChange(2)
                                }}
                            />
                            <PrimaryButton
                                label="Ending Soon"
                                className={topSort == 3 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(3)
                                    handleSortChange(3)
                                }}
                            />
                            <PrimaryButton
                                label="Most Popular"
                                className={topSort == 4 ? 'active' : ''}
                                onClick={() => {
                                    setTopSort(4)
                                    handleSortChange(4)
                                }}
                            />
                        </div>
                        {!isBidDepotProject && (
                            <div className="auctionSearchPaginationTop d-flex justify-content-between align-items-center flex-wrap my-5">
                                {/* {useCustomMediaQuery('(min-width: 1024px)') && ( */}
                                <Button className="filterToggle" onClick={manageFilterPanel}>
                                    <span className="material-icons-outlined">filter_list</span>
                                    Filters{' '}
                                    <span className="material-icons-outlined">
                                        {isFilterVisible ? 'expand_less' : 'expand_more'}
                                    </span>
                                </Button>
                                {/* )} */}
                                <PaginationComponent
                                    onPageChange={(value) => {
                                        document.getElementById('search-view').scrollIntoView()
                                        onHandlePage(value)
                                    }}
                                    totalProductCount={parseInt(totalItems)}
                                    currentPage={parseInt(formik.values.page)}
                                    resultToShow={parseInt(formik.values.sh_limit)}
                                />

                                <div className="auctionsMiscFilter">
                                    <div className="gridListToggle">
                                        <Button
                                            className={auctionView === 'Grid' ? 'active' : ''}
                                            onClick={() => setAuctionView('Grid')}
                                        >
                                            <span className="material-icons">apps</span>
                                        </Button>
                                        <Button
                                            className={auctionView === 'List' ? 'active' : ''}
                                            onClick={() => setAuctionView('List')}
                                        >
                                            <span className="material-icons">view_list</span>
                                        </Button>
                                    </div>
                                    <CustomSelect
                                        label="Results per page"
                                        name="resultsPerPage"
                                        selectType="noBorder"
                                        value={formik.values.sh_limit}
                                        size="small"
                                        onChange={(event, editor) => {
                                            formik.setFieldValue('page', 1)
                                            let currentUrl = new URL(window.location.href)
                                            if (currentUrl.searchParams.has('slimit')) {
                                                currentUrl.searchParams.set(
                                                    'slimit',
                                                    event.target.value,
                                                )
                                                window.history.replaceState({}, '', currentUrl)
                                            }
                                            formik.setFieldValue('sh_limit', event.target.value)
                                            sessionStorage.setItem('sh_limit', event.target.value)
                                        }}
                                    >
                                        {pageOptions.map((opt, optindex) => (
                                            <option value={opt.value}>{opt.show}</option>
                                        ))}
                                    </CustomSelect>
                                    <CustomSelect
                                        label="Sort by"
                                        value={params.get('sort') ?? formik.values.orderby}
                                        size="small"
                                        selectType="noBorder"
                                        name="orderby"
                                        // shrink={search.orderby !== '' ? true : false}
                                        onChange={(event, editor) => {
                                            {
                                                global?.storeConfigration?.liquidation_filter_update
                                                    ?.value == 1 &&
                                                global?.storeConfigration?.liquidation_filter_update
                                                    ?.value !== undefined
                                                    ? handleSortByFilter(event)
                                                    : formik.setFieldValue(
                                                          'orderby',
                                                          event.target.value,
                                                      )
                                                let currentUrl = new URL(window.location.href)
                                                currentUrl.searchParams.set(
                                                    'sort',
                                                    event.target.value,
                                                )
                                                window.history.replaceState({}, '', currentUrl)
                                            }
                                        }}
                                    >
                                        {global?.storeConfigration?.liquidation_filter_update
                                            ?.value == 1
                                            ? sortShow1.map((opt, optindex) => (
                                                  <option value={opt.value}>{opt.show}</option>
                                              ))
                                            : sortShow.map((opt, optindex) => (
                                                  <option value={opt.value}>{opt.show}</option>
                                              ))}
                                    </CustomSelect>
                                </div>

                                <Button
                                    className="toggleRespDrawer w-100"
                                    variant="outlined"
                                    onClick={toggleDrawer('bottom', true)}
                                >
                                    <span className="material-icons">tune</span>
                                    Filters
                                </Button>
                                {/* {global?.storeConfigration?.liquidation_filter_update?.value ==
                                1 ? null : (
                                    <CheckBox
                                        name="orderby"
                                        label="Time Remaining"
                                        className="asdasd"
                                        checked={checked}
                                        onChange={(event) => setChecked(!checked)}
                                    />
                                )} */}
                            </div>
                        )}
                    </>
                )}

                <div className="searchContainer">
                    <div className={`searchLt ${isFilterVisible ? '' : 'd-none'}`}>
                        <FilterPanel
                            formik={formik}
                            filterValues={filterValues}
                            allOpen={true}
                            locationInfo={isBidDepotProject ? true : null}
                        />
                    </div>

                    <div className={`searchRt ${isFilterVisible ? null : 'expandMore'}`}>
                        {isBidDepotProject ? (
                            <>
                                {/* <div className="sotingBtngrp">
                                    <PrimaryButton label="Active" />
                                    <PrimaryButton label="Completed" />
                                    <PrimaryButton label="Newest" />
                                    <PrimaryButton label="Ending Soon" />
                                    <PrimaryButton label="Most Popular" />
                                </div> */}
                                {/* <div className="sotingBtngrp mb-3 justify-content-end">
                                    <PrimaryButton
                                        label="Active"
                                        className={
                                            formik.values.closed_auction_list == 0 ? 'active' : ''
                                        }
                                        onClick={() =>
                                            formik.setFieldValue('closed_auction_list', 0)
                                        }
                                    />
                                    <PrimaryButton
                                        label="Completed"
                                        className={
                                            formik.values.closed_auction_list == 1 ? 'active' : ''
                                        }
                                        onClick={() =>
                                            formik.setFieldValue('closed_auction_list', 1)
                                        }
                                    />
                                </div> */}
                                <div className="auctionSearchPaginationTop d-flex justify-content-between align-items-center flex-wrap my-5">
                                    <h4 className="selectedCaterory mr-3">Apparel</h4>
                                    <PaginationComponent
                                        onPageChange={(value) => {
                                            document.getElementById('search-view').scrollIntoView()
                                            onHandlePage(value)
                                        }}
                                        totalProductCount={parseInt(totalItems)}
                                        currentPage={parseInt(formik.values.page)}
                                        resultToShow={parseInt(formik.values.sh_limit)}
                                    />
                                    {/* <h4 className="selectedSortOption">Active</h4> */}
                                    <div className="auctionsMiscFilter">
                                        <div className="gridListToggle">
                                            <Button
                                                className={auctionView === 'Grid' ? 'active' : ''}
                                                onClick={() => setAuctionView('Grid')}
                                            >
                                                <span className="material-icons">grid_view</span>{' '}
                                                Grid
                                            </Button>
                                            <Button
                                                className={auctionView === 'List' ? 'active' : ''}
                                                onClick={() => setAuctionView('List')}
                                            >
                                                <span className="material-icons">
                                                    format_list_bulleted
                                                </span>{' '}
                                                List
                                            </Button>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-start flex-nowrap">
                                            <b>Show Results</b>
                                            <CustomSelect
                                                label=""
                                                name="resultsPerPage"
                                                selectType="noBorder"
                                                value={formik.values.sh_limit}
                                                size="small"
                                                onChange={(event, editor) => {
                                                    formik.setFieldValue('page', 1)
                                                    formik.setFieldValue(
                                                        'sh_limit',
                                                        event.target.value,
                                                    )
                                                    sessionStorage.setItem(
                                                        'sh_limit',
                                                        event.target.value,
                                                    )
                                                }}
                                            >
                                                {pageOptions.map((opt, optindex) => (
                                                    <option value={opt.value}>{opt.show}</option>
                                                ))}
                                            </CustomSelect>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-start flex-nowrap">
                                            <b>Sort by</b>
                                            <CustomSelect
                                                label=""
                                                value={formik.values.orderby}
                                                size="small"
                                                selectType="noBorder"
                                                name="orderby"
                                                // shrink={search.orderby !== '' ? true : false}
                                                onChange={(event, editor) => {
                                                    {
                                                        global?.storeConfigration
                                                            ?.liquidation_filter_update?.value ==
                                                            1 &&
                                                        global?.storeConfigration
                                                            ?.liquidation_filter_update?.value !==
                                                            undefined
                                                            ? handleSortByFilter(event)
                                                            : formik.setFieldValue(
                                                                  'orderby',
                                                                  event.target.value,
                                                              )
                                                    }
                                                }}
                                            >
                                                {global?.storeConfigration
                                                    ?.liquidation_filter_update?.value == 1
                                                    ? sortShow1.map((opt, optindex) => (
                                                          <option value={opt.value} key={optindex}>
                                                              {opt.show}
                                                          </option>
                                                      ))
                                                    : sortShow.map((opt, optindex) => (
                                                          <option value={opt.value} key={optindex}>
                                                              {opt.show}
                                                          </option>
                                                      ))}
                                            </CustomSelect>
                                        </div>
                                        <Button
                                            className="depotFilterBtns"
                                            variant="outlined"
                                            onClick={manageFilterPanel}
                                        >
                                            <span className="material-icons-outlined mr-1">
                                                filter_alt
                                            </span>
                                            Filters
                                        </Button>
                                    </div>
                                </div>
                            </>
                        ) : null}
                        {isLoading ? (
                            <div>
                                <Loaders name="product_grid_view" isLoading={isLoading} loop={6} />
                            </div>
                        ) : viewProduct?.length !== 0 ? (
                            <div
                                className={`lotResults mb-4 ${auctionView} liquidationBuyCard ${
                                    !isAuthenticated ? 'unauth' : 'auth'
                                }`}
                            >
                                {viewProduct.map((data, index) =>
                                    auctionView === 'Grid' ? (
                                        <>
                                            {
                                                <GridProduct
                                                    data={data}
                                                    viewProduct={viewProduct}
                                                    setViewProduct={setViewProduct}
                                                    className={data.auction ? 'auction' : 'buynow'}
                                                    key={index}
                                                    type={data.auction ? 'auction' : 'buynow'}
                                                    selectedProduct={selectedProduct}
                                                    link={`/gallery/product-view/${data.id}`}
                                                    handleClick={handleClick}
                                                    timerTheme=""
                                                    bidStatus={true}
                                                    sliderTheme="multiseller"
                                                    currencyType="usd"
                                                    timerIcon={true}
                                                    cardTheme="bidAuction"
                                                    bidBtnLabel="Place Bid"
                                                />
                                            }
                                        </>
                                    ) : (
                                        <MultisellerListCard
                                            cardTheme="bidAuction"
                                            lotData={data}
                                            viewProduct={viewProduct}
                                            setViewProduct={setViewProduct}
                                            className={data.auction ? 'auction' : 'buynow'}
                                            key={index}
                                            bidStatus={true}
                                            selectedProduct={selectedProduct}
                                            allsearchitems={viewProduct}
                                            type="lot"
                                            handleClick={handleClick}
                                            details={`/gallery/product-view/${data.id}`}
                                            sliderTheme="multiseller"
                                            card_theme="liquidationTwo"
                                            standalonePage={true}
                                            bidBtnLabel={
                                                <>
                                                    <span className="material-icons-outlined">
                                                        gavel
                                                    </span>
                                                    Bid
                                                </>
                                            }
                                        />
                                    ),
                                )}
                            </div>
                        ) : (
                            <NoRecordsFound />
                        )}
                        <PaginationComponent
                            onPageChange={(value) => {
                                document.getElementById('search-view').scrollIntoView()
                                onHandlePage(value)
                            }}
                            totalProductCount={parseInt(totalItems)}
                            currentPage={parseInt(formik.values.page)}
                            resultToShow={parseInt(formik.values.sh_limit)}
                        />
                    </div>
                </div>
            </div>

            <Drawer
                anchor="bottom"
                open={state['bottom']}
                className="responsiveFilterDrawer"
                onClose={toggleDrawer('bottom', false)}
                onOpen={toggleDrawer('bottom', true)}
            >
                <div
                    className={clsx(classes.list, 'bottom')}
                    role="presentation"
                    // onClick={toggleDrawer('bottom', false)}
                    onKeyDown={toggleDrawer('bottom', false)}
                >
                    <FilterPanel formik={formik} filterValues={filterValues} />
                </div>
            </Drawer>
            {/* <MultisellerSlider
                storeTheme="Liquidation_two"
                selectedLot={selectedProduct}
                handleClose={handleClose}
                currency="cad"
                type={props.type ? props.type : ''}
            /> */}
            <React.Fragment>
                <SwipeableDrawer
                    className="respHeaderSearch"
                    anchor={'top'}
                    open={state['top']}
                    disableBackdropTransition={!iOS}
                    disableDiscovery={iOS}
                    disableSwipeToOpen={false}
                    onClose={toggleDrawer('top', false)}
                    onOpen={toggleDrawer('top', true)}
                >
                    <HeaderSearchComponent />
                </SwipeableDrawer>
            </React.Fragment>
        </Layout>
    )
}

export default AuctionSearchComponent
